import { MatchRepository } from "../repositories/MatchRepository";
import { UserInfoProfile } from "../entities/userInfoProfile";

export class GetUserInfoById {
	constructor(private repository: MatchRepository) {}
	execute(params: GetUserInfoByIdParams): Promise<UserInfoProfile> {
		return this.repository.getUserInfoById(params.params);
	}
}

export class GetUserInfoByIdParams {
	constructor(
		public params: {
			user_id: string;
			user_lat: string;
			user_lng: string;
			distance_origin_lat?: string;
			distance_origin_lng?: string;
		}
	) {}
}
